import KeyFigureSeriesSpecification from "./KeyFigureSeriesSpecification.js";
import Model from "../../Model.js";
import PeriodRollingSeriesSpecification from "./PeriodRollingSeriesSpecification.js";
import RowSeriesSpecification from "./RowSeriesSpecification.js";

/**
 * Builds default series specifications using the company's
 * keyFigures.
 *
 * @param {KeyFigure[]} keyFigures - List of all available keyFigures
 */
export default class SeriesSpecificationBuilder extends Model {
	constructor({ keyFigures = [] }) {
		super(...arguments);

		this._keyFigureMap = this._makeKeyFigureMap({ keyFigures });
		this._seriesSpecifications = [];
	}

	withPeriodRollingSeriesSpecification({
		id,
		keyFigureId,
		rollingLength,
		operationType,
	}) {
		return this._with(
			PeriodRollingSeriesSpecification.makeFromModel({
				id,
				keyFigure: this._getKeyFigure(keyFigureId),
				rollingLength,
				operationType,
			}),
		);
	}

	withRowSeriesSpecification({ report }) {
		RowSeriesSpecification.makeForReport({ report }).forEach(
			this._with.bind(this),
		);

		return this;
	}

	withKeyFigureSeriesSpecification({ keyFigureId, report }) {
		return this._with(
			KeyFigureSeriesSpecification.makeFromModel({
				keyFigure: this._getKeyFigure(keyFigureId),
				report,
			}),
		);
	}

	withKeyFiguresSeriesSpecificationAndOperationType({
		keyFigureId,
		operationType = "Change",
	}) {
		const keyFigure = this._getKeyFigure(keyFigureId);
		if (!keyFigure) return this;
		return this._with(
			KeyFigureSeriesSpecification.makeFromModel({
				operationType,
				keyFigure,
			}),
		);
	}

	build() {
		return this._seriesSpecifications;
	}

	_makeKeyFigureMap({ keyFigures }) {
		return new Map(
			keyFigures.map((keyFigure) => [keyFigure.getId(), keyFigure]),
		);
	}

	_getKeyFigure(keyFigureId) {
		return this._keyFigureMap.get(keyFigureId);
	}

	_with(seriesSpecification) {
		this._seriesSpecifications.push(seriesSpecification);
		return this;
	}
}
